"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.translationsNamespace = exports.defaultTranslations = void 0;
/* istanbul ignore file @preserve */
/**
 * DO NOT EDIT!
 * This file was autogenerated by npm script `localizations-codegen`.
 * Changes may cause incorrect behavior and will be lost when the file is regenerated.
 *
 * Run `npx localizations-codegen` to regenerate.
 */

const defaultTranslations = exports.defaultTranslations = {
  bonusPoints: 'Bonus points',
  buy: 'Buy',
  choose: 'Choose',
  favorites: 'Favorites',
  goBack: 'Go back',
  lowestPrice: 'Our lowest price, the last 30 days before current price, was',
  productIsDiscontinued: 'Product is discontinued',
  productIsDiscontinuedDescription: 'The product you are looking for has been discontinued and is no longer for sale.',
  productNotFound: 'Product not found',
  productNotFoundDescription: 'We are experiencing technical difficulties and the product cannot be found.',
  replace: 'Replace',
  replaceWith: 'Replace with',
  reserve: 'Reserve',
  subscribe: 'Subscribe',
  viewMoreDetails: 'View more details'
};
const translationsNamespace = exports.translationsNamespace = 'product-info-dialog';